import React from 'react';

// Shared page context for Regi. Any page can write to this so Regi knows what the user
// is currently viewing, without Regi being nested inside that page's component tree.
//
// Shape of context object (all fields optional):
//   { page, supplierName, supplierId, emailSubject, emailFrom, emailDate }

const RegiPageContext = React.createContext({ context: null, setContext: () => {} });

export const RegiPageProvider = ({ children }) => {
    const [context, setContext] = React.useState(null);
    const value = React.useMemo(() => ({ context, setContext }), [context]);
    return <RegiPageContext.Provider value={value}>{children}</RegiPageContext.Provider>;
};

export const useRegiPageContext = () => React.useContext(RegiPageContext);
